import React, { FC } from "react";

import { Stack } from "@mui/material";

import { ReduxTextField } from "../../../../components/Redux/TextField";
import SettingSection from "../../../../components/SettingSection";
import {
  getRouteFormProperty,
  setRouteFormError,
  setRouteFormProperty,
} from "../../../../slices/routes";
import { notEmpty } from "../../../../validators/not-empty";
import { validToUrl } from "../../../../validators/url";
import FromField from "../fields/FromField";
import PolicyPicker from "../fields/PolicyPicker";

interface RouteSettingsProps {
  refresh: string;
  readonly: boolean;
}

export const RouteSettings: FC<RouteSettingsProps> = ({
  refresh,
  readonly,
}) => {
  return (
    <Stack key={refresh} direction="column" spacing={1}>
      <SettingSection label="Route Name" docsKey="name">
        <ReduxTextField
          disabled={readonly}
          fullWidth
          path="name"
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          errorHandler={setRouteFormError}
          validator={notEmpty}
        />
      </SettingSection>
      <SettingSection label="From" docsKey="from">
        <FromField readonly={readonly} />
      </SettingSection>
      <SettingSection label="To" docsKey="to">
        <ReduxTextField
          getter={getRouteFormProperty}
          setter={setRouteFormProperty}
          errorHandler={setRouteFormError}
          placeholder="https://<ip>:6443"
          path={"to.0"}
          validator={validToUrl}
        />
      </SettingSection>
      <SettingSection label="Policies" docsKey="policies">
        <PolicyPicker readonly={readonly} />
      </SettingSection>
    </Stack>
  );
};
